import React, { ReactElement } from "react";
import styles from "./StaticVersion.module.css";

interface props {
  version: string;
  show: boolean;
}
const StaticVersion: React.FC<props> = ({ version, show }): ReactElement => (
  <>
    {show && (
      <div className={styles.StaticVersion}>
        <span className={styles.StaticVersionHeader}>v{version}</span>
      </div>
    )}
  </>
);

export default StaticVersion;
